import { makeRESTApiRequest } from './api';
import { ENDPOINTS } from './constants';

export const fetchAuditLogs = async (serviceId, { cursor, orderId, search, type, signal } = {}) => {
  const params = new URLSearchParams({ serviceId });
  if (cursor) params.set('cursor', cursor);
  if (orderId) params.set('orderId', orderId);
  if (search) params.set('search', search);
  if (type) params.set('type', type);

  return makeRESTApiRequest({
    endpoint: `${ENDPOINTS.AUDIT_LOGS}?${params.toString()}`,
    method: 'GET',
    signal
  });
};
